export const formatFullName = (entity: {
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
} | null | undefined): string => {
  if (entity == null || entity.firstName == null || entity.lastName == null) {
    return '';
  }
  if (entity.middleName) {
    return `${entity.firstName} ${entity.middleName} ${entity.lastName}`;
  }
  return `${entity.firstName} ${entity.lastName}`;
};
